export const ICC_SSO_AD_DEEPLINK_TEMPLATE = 'RAB_SSO_AD_{deviceType}_{marketCode}_{languageCode}';
export const ICC_SSO_GUIDE_DEEPLINK_TEMPLATE = 'RAB_SSO_GUIDE_{deviceType}_{marketCode}_{languageCode}';
